import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { OrderCreditModel } from '../models/order-credit.model';

export class OrderCreditsApiService extends ApiService {
  static endpoint = 'order-credits';

  /**
   * @param {String|Number} id
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderCreditModel>>}
   * @public
   */
  static async patch(id, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildUrl(id), data, {
      ...config,
      dataModel: OrderCreditModel,
      useThemeApi: true,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }
}
